import React, { useState } from "react";

function TableRow({ cell, index }) {
  const [showMore, setShowMore] = useState(false);
  const [clientArraylength, setclientArraylength] = useState(1);
  const [Arraylength, setArraylength] = useState(1);
  const [PropArrayLength, setPropArrayLength] = useState(1);
  var arrayLength = 0
  var showArray = [];
  if (cell.column?.id === "clients") {
    arrayLength = (cell?.value?.toString().split(',')?.length);
    showArray = cell?.value?.toString().split(',');

  }
  if (cell.column?.id === "propertyAddress") {
    arrayLength = (cell?.value?.toString().split(';')?.length);
    showArray = cell?.value?.toString().split(';');

  }
  if (cell.column?.id === "closingDate") {
    arrayLength = (cell?.value?.toString().split(',')?.length);
    showArray = cell?.value?.toString().split(',');

  }
  return (
    <td
      key={index}
      className="pb-[16px] pt-[24px] text-left pr-4 pl-4 w-max"
      {...cell.getCellProps()}
      style={{ whiteSpace: 'pre-wrap' }}
    >
      {(cell.column?.id === "clients" ||
        cell.column?.id === "propertyAddress" ||
        cell.column?.id === "closingDate") &&
        arrayLength > 2 &&
        !showMore
        ? `${
        //spread the props
        showArray.slice(0, 2).join('\n').toString()

        }` + '...'
        : cell.render("Cell")}

      {(cell.column?.id === "clients" ||
        cell.column?.id === "propertyAddress" ||
        cell.column?.id === "closingDate") &&
        arrayLength > 2 && (
          <button className="btn" onClick={() => setShowMore(!showMore)}>
            {showMore ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-chevron-down"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-chevron-right"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                />
              </svg>
            )}
          </button>
        )}

      {/* {cell.value.toString().length >= 100 ? (
                            <>
                              <div>
                                {cell.value.toString().substring(0, 100)}{" "}
                              </div>
                              <button >
                                <svg
                                  aria-hidden="true"
                                  width="24"
                                  height="24"
                                  fill="none"
                                >
                                  <path
                                    d="m6 9 6 6 6-6"
                                    stroke="#000"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                </svg>
                              </button>
                            </>
                          ) : (
                            cell.render("Cell")
                          )} */}
    </td>
  );
}

export default React.memo(TableRow);
